import React from 'react';
import {Autocomplete, TextField} from '@mui/material';
import {Controller, useWatch} from 'react-hook-form';
import {get} from 'lodash';
import {useSelector} from 'react-redux';

const TaxCategorySelect = ({
                               id,
                               name,
                               label = 'Tax Category',
                               control,
                               errors,
                               disabled = false,
                               readOnly = false,
                               onChange,
                           }) => {
    const taxCategoryOptions = useSelector((state) => state.codeLists.taxCategoriesList) ?? [];
    // Use useWatch to get the current form value, which stays in sync with setValue calls
    const currentValue = useWatch({control, name});

    return (
        <Controller
            name={name}
            control={control}
            render={({field}) => {
                // Handle both string (category code) and object (full tax category object) cases
                // Use currentValue from useWatch to ensure we have the latest value (stays in sync with setValue calls)
                const fieldValue = typeof currentValue === 'string' ? currentValue : currentValue?.category;
                const selectedOption = taxCategoryOptions.find((opt) => opt.category === fieldValue) ?? null;

                return (
                    <Autocomplete
                        id={id || name}
                        options={taxCategoryOptions}
                        readOnly={readOnly}
                        fullWidth={true}
                        getOptionLabel={(option) => `${option.category} - ${option.description}`}
                        isOptionEqualToValue={(option, value) => option.category === value?.category}
                        value={selectedOption}
                        onChange={(_, selected) => {
                            // If there's an external onChange handler, let it manage the form value via setValue
                            // useWatch will pick up the change and update the component
                            if (onChange) {
                                onChange(selected ?? null); // external handler will call setValue
                            } else {
                                // No external handler, update the Controller's field directly
                                field.onChange(selected ?? null);
                            }
                        }}
                        onBlur={field.onBlur}
                        name={field.name}
                        renderInput={(params) => {
                            const errorObj = get(errors, name);
                            return (
                                <TextField
                                    {...params}
                                    label={label}
                                    fullWidth={true}
                                    error={!!errorObj}
                                    helperText={errorObj?.message}
                                />
                            );
                        }}
                    />
                );
            }}
            disabled={disabled}
        />
    );
};

export default TaxCategorySelect;
